import { render, staticRenderFns } from "./TheProjectInvestorsCircles.vue?vue&type=template&id=c5f05c68&"
import script from "./TheProjectInvestorsCircles.vue?vue&type=script&lang=js&"
export * from "./TheProjectInvestorsCircles.vue?vue&type=script&lang=js&"
import style0 from "./TheProjectInvestorsCircles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports